'use client';

import { useReportWebVitals } from 'next/web-vitals';

/**
 * Real-User Monitoring for Core Web Vitals.
 *
 * Uses Next.js built-in useReportWebVitals (no extra dependency).
 * Pipes CLS / LCP / INP / FCP / TTFB to Google Analytics so regressions show up
 * in the field BEFORE they surface in PageSpeed Insights / CrUX (which lags 28 days).
 *
 * Without this hook, the team only finds out about CWV regressions from the CrUX
 * report — by which time the bad version has been live for weeks.
 */
export default function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    // Only ship data when gtag is available (GA loads via lazyOnload / user-interaction).
    // If the user never interacts, we skip — which is fine for bounces.
    const gtag = (
      window as unknown as { gtag?: (...args: unknown[]) => void }
    ).gtag;
    if (typeof gtag !== 'function') return;

    const value =
      metric.name === 'CLS'
        ? Math.round(metric.value * 1000) // CLS is fractional — multiply for integer precision
        : Math.round(metric.value);

    gtag('event', metric.name, {
      event_category: 'Web Vitals',
      value,
      metric_id: metric.id,
      metric_value: metric.value,
      metric_delta: metric.delta,
      metric_rating: metric.rating, // 'good' | 'needs-improvement' | 'poor'
      non_interaction: true,
    });
  });

  return null;
}
